import { createAsyncThunk } from '@reduxjs/toolkit';
import { GameInfoMapped } from 'modules/overlay-v2/domain/interfaces/game-info/gameInfoMapped';
import { getGameInfoImageUrls } from 'modules/overlay-v2/domain/utils/get-game-info-image-urls';
import { preloadImages, PreloadImagesResult } from 'shared/utils/preload-images';

const PREFIX = 'overlay-v2/readiness';

/**
 * Общий бюджет на прогрев картинок. У `preloadImages` по умолчанию 15 минут — это
 * рассчитано на фоновую догрузку, а здесь прогрев стал видимым шагом чеклиста, и
 * держать оператора на экране подготовки четверть часа нельзя.
 */
export const ASSETS_PRELOAD_TIMEOUT_MS = 60_000;

/**
 * Заранее скачивает лого команд, эмблему организатора и фото игроков, чтобы Fabric
 * рисовал доски мгновенно и без «прыжка» пустых плейсхолдеров.
 *
 * Не падает от битой картинки: `preloadImages` всегда резолвится, а отчёт
 * `{ loaded, failed }` превращается в жёлтую пометку шага.
 */
export const preloadGameInfoAssets = createAsyncThunk<PreloadImagesResult, { gameInfo?: GameInfoMapped }>(
  `${PREFIX}/preloadAssets`,
  async ({ gameInfo }) => {
    return preloadImages(getGameInfoImageUrls(gameInfo), { totalTimeoutMs: ASSETS_PRELOAD_TIMEOUT_MS });
  },
);
